<template>
  <svg :width="width" :height="height" class="row"></svg>
</template>

<script>
import * as d3 from "d3";
import d3tip from "d3-tip";

export default {
  mounted: function() {
    this.svg = d3.select(this.$el);
    this.colors = d3.scaleOrdinal(d3[this.colorScheme]);

    this.tip = d3tip()
      .attr("class", "d3-tip")
      .offset([-10, 0])
      .html(function(d) {
        return (
          "<div><span style='color:white'>" +
          d.data.name +
          "</span></div>" +
          "<div><span>Value:</span> <span style='color:white'>" +
          d.data.value +
          "</span></div>"
        );
      });

    this.svg.call(this.tip);

    this.drawChart(this.isMobile);
  },
  watch: {
    isMobile: function(newIsMobile) {
      this.drawChart(newIsMobile);
    }
  },
  methods: {
    drawChart: function(isMobile) {
      this.svg.selectAll("*").remove();
      let colors = this.colors;
      let data = d3
        .pie()
        .sort(null)
        .value(function(d) {
          return d.value;
        })(this.data);

      let segments = d3
        .arc()
        .innerRadius(this.innerRadius)
        .outerRadius(this.outerRadius)
        .padAngle(this.padAngle)
        .padRadius(50);

      let sections = this.svg
        .append("g")
        .attr("transform", "translate(150, 250)")
        .selectAll("path")
        .data(data);

      sections
        .enter()
        .append("path")
        .attr("d", segments)
        .attr("fill", function(d) {
          return colors(d.data.value);
        })
        .on("mouseover", this.tip.show)
        .on("mouseout", this.tip.hide);

      let content = d3
        .select("g")
        .selectAll("text")
        .data(data);

      content
        .enter()
        .append("text")
        .classed("innertext", true)
        .each(function(d) {
          let center = segments.centroid(d);
          d3.select(this)
            .attr("x", center[0])
            .attr("y", center[1])
            .attr("transform", "rotate(-5)")
            .text(d.data.value);
        });

      let legends = this.svg
        .append("g")
        .attr(
          "transform",
          `${isMobile ? "translate(100, 450)" : "translate(400, 150)"}`
        )
        .selectAll(".legends")
        .data(data);

      let legend = legends
        .enter()
        .append("g")
        .classed("legends", true)
        .attr("transform", function(d, i) {
          return "translate(0, " + (i + 1) * 30 + " )";
        });

      legend
        .append("rect")
        .attr("width", 20)
        .attr("height", 20)
        .attr("fill", function(d) {
          return colors(d.data.value);
        });

      legend
        .append("text")
        .classed("label", true)
        .text(function(d) {
          return d.data.name;
        })
        .attr("fill", function(d) {
          return colors(d.data.value);
        })
        .attr("x", 30)
        .attr("y", 17);
    }
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    width: {
      default: "600"
    },
    height: {
      default: "500"
    },
    innerRadius: {
      default: 0
    },
    outerRadius: {
      default: 150
    },
    colorScheme: {
      default: "schemeAccent"
    },
    padAngle: {
      default: 0.05
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
svg {
  position: relative;
  display: flex;
  justify-content: space-around;
}
.innertext {
  fill: aliceblue;
  font-size: 15px;
  font-weight: bold;
}
.label {
  font-size: 15px;
  font-weight: bold;
}
rect,
path,
circle {
  transition: all 500ms ease;
}
</style>
